module.exports = __webpack_public_path__ + "static/media/DasLeuchtenDerWeihnacht.60f796c2.jpg";